export default {"src":"/_next/static/media/bahamas.09165f1a.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};